
import { Component, Input, OnInit } from '@angular/core';
import { DurationPipe, DynamicDatePipe } from '@shared/pipes.pipe';
import { SetList } from 'app/core/models/setlist.interface';
import moment from 'moment';

@Component({
    selector: 'app-print-setlist-container',
    templateUrl: './print-setlist-container.component.html',
    imports: [
    DynamicDatePipe,
    DurationPipe
]
})
export class PrintSetlistContainerComponent implements OnInit {
    @Input() bandData!: any;
    @Input() setlistData!: SetList;
    @Input() appointmentData!: any;

    showBpm = false;
    showTuning = false;
    showComment = false;

    ngOnInit(): void {
        if (this.setlistData?.setlistSongs) {
            this.evaluateColumnsVisibility(this.setlistData.setlistSongs);
        }
    }

    formatDate(date: string): string {
        return moment(date).format('YYYY-MM-DD');
    }

    evaluateColumnsVisibility(songs: any[]): void {
        this.showBpm = songs.some((song) => song.song.bpm !== undefined && song.song.bpm !== null);
        this.showTuning = songs.some((song) => song.song.tuning !== undefined && song.song.tuning !== null);
        this.showComment = songs.some((song) => song.song.comment && song.song.comment.trim() !== '');
    }
}
